import { AbstractError } from 'Framework/Error/AbstractError.js'

export class UnauthorizedError extends AbstractError {}
